import adminService from '../admin/index.js'

export const paidTasksApi = {
  getList(params) {
    return adminService.get('/admin/paid-tasks', { params })
  },
  getDetail(id) {
    return adminService.get(`/admin/paid-tasks/${id}`)
  },
  updateStatus(id, status) {
    return adminService.put(`/admin/paid-tasks/${id}/status`, { status })
  },
  getStatistics() {
    return adminService.get('/admin/paid-tasks/statistics/overview')
  }
}
